import { useMutation } from "@tanstack/react-query";
import dateFormat from "dateformat";
import useQueueStore from "../../stores/queue-store";
import scheduleAppointment from "../../controllers/appointments/schedule-appointment";

const useScheduleAppointment = () => {
  const setSelectedDate = useQueueStore((state) => state.setSelectedDate);

  return useMutation(scheduleAppointment, {
    onSuccess: (data, { startTime }) => {
      if (data.success) {
        setSelectedDate(new Date(dateFormat(startTime, "yyyy-mm-dd")));
      }
    },
  });
};

export default useScheduleAppointment;
